import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
    TimeSeriesAnalysisIdentifierListFacade
} from '@backoffice-frontend/time-series-identifier/domain';
import type { TimeSeriesAnalysisIdentifier } from '@clean-code/models';
import { ActionButtonModule } from '@clean-code/shared/components/ui-action-button';
import { DataTableBaseComponent } from '@clean-code/shared/components/ui-data-table';
import { TableStateService, UiMatTableModule } from '@clean-code/shared/components/ui-mat-table';
import { PageContainerModule } from '@clean-code/shared/components/ui-page-container';
import { YesNoPipe } from '@clean-code/shared/ui-pipes';
import { TranslocoModule } from '@jsverse/transloco';
import {
    TimeSeriesAnalysisIdentifierSearchModule
} from './components/time-series-analysis-identifier-search/time-series-analysis-identifier-search.module';

@Component({
  templateUrl: './time-series-analysis-identifier-list.component.html',
  styleUrls: ['./time-series-analysis-identifier-list.component.scss'],
  imports: [
    AsyncPipe,
    RouterLink,
    TranslocoModule,
    YesNoPipe,
    UiMatTableModule,
    ActionButtonModule,
    TimeSeriesAnalysisIdentifierSearchModule,
    PageContainerModule,
  ],
  providers: [TableStateService],
})
export class TimeSeriesAnalysisIdentifierListComponent extends DataTableBaseComponent<TimeSeriesAnalysisIdentifier> {
  public override navigateUrl = '/settings/time-series-analysis-identifier';

  constructor() {
    const service = inject(TimeSeriesAnalysisIdentifierListFacade);
    super(service);
  }
}
